import { inProgressBlackIcon, warningIconBlack, xCloseIcon } from 'utils/assets';

import styles from './PositionSyncAlert.module.scss';

export type PositionSyncAlertVariant = 'info' | 'loading' | 'error';

interface PositionSyncAlertProps {
  variant: PositionSyncAlertVariant;
  title: string;
  message: string;
  onClose: () => void;
}

export default function PositionSyncAlert({
  variant,
  title,
  message,
  onClose,
}: Readonly<PositionSyncAlertProps>) {
  return (
    <section className={`${styles.alert} ${styles[`alert--${variant}`]}`} role='status'>
      <div className={styles.alert__icon}>
        {variant === 'loading' ? (
          <img src={inProgressBlackIcon} alt='' className={styles.alert__spinner} />
        ) : (
          <img src={warningIconBlack} alt='' />
        )}
      </div>

      <div className={styles.alert__content}>
        <p className={styles.alert__title}>{title}</p>
        <p className={styles.alert__text}>{message}</p>
      </div>

      <button type='button' className={styles.alert__close} onClick={onClose} aria-label='Cerrar'>
        <img src={xCloseIcon} alt='' />
      </button>
    </section>
  );
}
